//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const GetRecommendedCarsApi = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseURL}/cars/recommended`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
}